import { divRoundHalfAway } from "./money";

export const LABEL_ADULTS = "Ενήλικες";
export const LABEL_CHILDREN_HALF = "Παιδιά έως 11 (μισή τιμή)";
export const LABEL_CHILDREN_FREE = "Παιδιά έως 3,5 (δωρεάν)";

export const CHILD_PRICE_RULE_EL =
  "Τα παιδιά έως 11 ετών είναι στη μισή τιμή ανά άτομο, στο μισό της τιμής ενηλίκου αυτής της προσφοράς. Τα παιδιά έως 3,5 ετών είναι δωρεάν και μένουν στη γραμμή με ποσό 0.";

/** Half of one adult per-person price, in integer minor units. Half-cents round away from zero. */
export function halfPersonPriceMinor(adultUnitMinor: number): number {
  return divRoundHalfAway(BigInt(adultUnitMinor), 2n);
}

/**
 * Line total for `quantityMilli` guests at half the adult price.
 * Rounds once, at the line total, the same way other money is rounded.
 */
export function halfLineMinor(quantityMilli: number, adultUnitMinor: number): number {
  return divRoundHalfAway(BigInt(quantityMilli) * BigInt(adultUnitMinor), 2000n);
}

export function offerGuestLabel(adults: number | null, children: number | null, childrenFree: number | null, language: "el" | "en"): string {
  const half = children != null && children > 0 ? children : 0;
  const free = childrenFree != null && childrenFree > 0 ? childrenFree : 0;
  if (language === "el") {
    const parts: string[] = [];
    if (adults != null) parts.push(`${adults} ενήλικες`);
    if (half > 0) parts.push(`${half} ${half === 1 ? "παιδί" : "παιδιά"} έως 11`);
    if (free > 0) parts.push(`${free} ${free === 1 ? "παιδί" : "παιδιά"} έως 3,5`);
    return parts.length ? parts.join(", ") : "Χωρίς καταμέτρηση ατόμων";
  }
  if (adults == null && children == null && free === 0) return "Guest count unknown";
  const parts = [`${adults ?? "unknown"} adults`, `${children ?? "unknown"} children`];
  if (free > 0) parts.push(`${free} children up to 3.5, free`);
  return parts.join(", ");
}
